import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import usePrerenderReady from '@/lib/usePrerenderReady';
import SEO from '@/components/SEO';
import { faqItems } from '@/lib/faqContent';
import { trackEvent } from '@/lib/analytics';

const FAQ = () => {
  usePrerenderReady(false);
  useEffect(() => {
    trackEvent('faq_page_view');
  }, []);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <main className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-purple-50 pt-24 sm:pt-32">
      <SEO
        title="Frequently Asked Questions"
        description="Find answers about Kalamanch.art website and Android app usage, artist verification, PMB messaging, push notifications, account deletion, privacy, and trust safety."
        keywords="Kalamanch FAQ, artist signup, collaborator signup, Android app FAQ, PMB messages, push notification, account deletion"
        schema={faqSchema}
      />

      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="text-center mb-12">
          <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#FF6F00] mb-4">FAQ</p>
          <h1 className="text-4xl sm:text-5xl font-bold gradient-text mb-5">Frequently Asked Questions</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Quick answers for artists, collaborators, and visitors using Kalamanch.art on website and Android app.
          </p>
        </div>

        <div className="space-y-5">
          {faqItems.map((item) => (
            <article key={item.question} className="rounded-[2rem] bg-white p-6 sm:p-7 shadow-lg ring-1 ring-orange-100">
              <h2 className="text-xl font-bold text-gray-900">{item.question}</h2>
              <p className="mt-3 text-gray-600 leading-relaxed">{item.answer}</p>
            </article>
          ))}
        </div>

        <div className="mt-10 rounded-[2rem] bg-gradient-to-br from-[#4A148C] to-[#FF6F00] p-6 sm:p-8 text-center text-white shadow-xl">
          <h2 className="text-3xl font-bold mb-3">Still have a question?</h2>
          <p className="text-white/90 mb-6">
            Contact Kala Manch support for profile, media, verification, PMB, or Trust & Safety help.
          </p>
          <Link to="/contact" className="inline-flex rounded-full bg-white px-8 py-3 font-semibold text-[#4A148C] transition hover:bg-orange-50">
            Contact Support
          </Link>
        </div>
      </section>
    </main>
  );
};

export default FAQ;
